import _ from 'lodash';

import { NAME } from './constants/constants';

export const getNotificationsCount = (state) => _.get(state, `${NAME}.unreadCounters`, {});

export const getForumNotificationsCount = (state) => {
  const counts = getNotificationsCount(state);
  return _.defaultTo(counts.forumNotifications, 0);
};

export const getAlertsCount = (state) => {
  const counts = getNotificationsCount(state);
  return _.defaultTo(counts.alerts, 0);
};

export const getPrivateMessagesCount = (state) => {
  const counts = getNotificationsCount(state);
  return _.defaultTo(counts.privateMessages, 0);
};

export const getOldPrivateMessagesCount = (state) => {
  const counts = getNotificationsCount(state);
  return _.defaultTo(counts.oldPrivateMessages, 0);
};

export const getTotalPrivateMessagesCount = (state) =>
  getPrivateMessagesCount(state) + getOldPrivateMessagesCount(state);

export const getTotalNotificationCount = (state) =>
  getTotalPrivateMessagesCount(state) + getForumNotificationsCount(state);
